<template>
	<div class="stationManagement ">
		<div class="itemTitleBox disBetween">
			<div class="disStart">
				<span class="title">充电站管理</span>
			</div>
			<!-- <div class="icon_add iconBox" @click="openDia(5)" title="新建充电站"></div> -->
		</div>
		<div class="listBox disBetween" v-if="stationList && stationList.length>0" v-loading="loading">
			<div class="toLeft goItem" :class="{left:searchObj.pageNo==1}" @click="toLeft"></div>
			<div class="contentBox scrollContBox">
				<ul ref="scrollview" class="scrollUl">
					<li v-for="(item,inx) in stationList" :key="inx" class="scrollLi" :class="{active:active==inx}"
						@click="stationClick(item,inx)">
						<div class="itemBox disBetween">
							<div class="nameBox"></div>
							<!-- <div class="nameBox">{{item.communitySiteName}}</div> -->
							<el-popover class="mypopover disCenter" placement="top-end" width="100" trigger="hover">
								<div class="pupBox">
									<span class="hoverClass" @click.stop="itemClick(item,inx,1)">详情</span>
									<span class="hoverClass" @click.stop="itemClick(item,inx,2)">删除</span>
								</div>
								<div slot="reference" class="listIcon"></div>
							</el-popover>
						</div>
						<div class="itemBox disBetween">
							<span class="secondItem">设备数量：{{item.communityEquipmentNumber}}</span>
							<span class="secondItem">异常：{{item.communityAbnormalEquipmentNumber}}</span>
						</div>
						<div class="itemBox disBetween">
							<span class="adressIcon"></span>
							<span class="adressBox">{{item.communitySiteName}}</span>
							<!-- <span class="adressBox">{{item.communitySiteAddress}}</span> -->
						</div>
					</li>
				</ul>
			</div>
			<div class="toRight goItem" :class="{right:(searchObj.pageNo*3>=total)}" @click="toRight"></div>
		</div>
		<div v-else class="nodataBox">
			<nodata :str="str">
				<template v-slot>
					<div class="slotBox">
						<div class="disStart">
							<!-- <div class="disStart" @click="openDia(5)" title="新建充电站"> -->
							<!-- <span class="icon_add2"></span> -->
							<!-- <span>新建充电站</span> -->
						</div>
					</div>
				</template>
			</nodata>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="充电站名称" >
								<!-- prop="name" -->
								<div class="myinputBox">
									<el-input disabled v-model="creatObj.name" placeholder="请输入充电站名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="省市区">
								<div class="myinputBox myinputBox2">
									<el-input disabled v-model="area" placeholder="请输入省市区">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<!-- <div class="diaItem disStart">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="具体地址" prop="adress">
								<div class="myinputBox myinputBox3">
									<el-input clearable id="userInput" v-model="creatObj.adress"
										placeholder="请输入具体地址 / 社区名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div> -->
					<div class="disCenter">
						<div id="mapBox"></div>
					</div>
					<div class="disStart">
						<div class="latBox">经纬度：</div>
						<div v-if="creatObj.lng">
							{{creatObj.lng}} , {{creatObj.lat}}
						</div>
					</div>
				</div>
				<!-- <span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="toSave">保 存</el-button>
				</span> -->
				<el-form-item class="diabtnBox disCenter">
					<el-button type="primary" @click="dialogVisible=false">确 定</el-button>
					<!-- <el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm2')">保 存</el-button> -->
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		stationList
	} from "@/assets/js/data.js"
	import AMapLoader from "@amap/amap-jsapi-loader";
	import nodata from "../../../nodata/nodata.vue"
	let Amap;
	window._AMapSecurityConfig = {
		// securityJsCode: 'fbfe9ed39101632111f069d76bf27a88',//测试环境
		securityJsCode: '92759b91f4a3029c8c63614b87eebedc', //正式环境 
	}
	var token = localStorage.getItem('token')
	export default {
		name: "stationManagement",
		components: {
			nodata
		},
		props: {
			areaList: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				str: "您还没有相应的充电站",
				stationList: [],
				left: true,
				right: false,
				active: -1,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 3, //当前页个数
					search: "", //搜索
					communityId: "" //社区编号
				},
				total: 0,
				creatObj: {
					name: "",
					type: "",
					adress: "",
					// 经度
					lng: '',
					// 维度
					lat: ''
				},
				area: "",
				auto: null,
				placeSearch: null,
				NOfalse: false,
				dialogTitle: "新建站点",
				dialogVisible: false,
				loading: false,
				rules: {
					name: [{
						required: true,
						message: '请输入站点名称',
						trigger: 'blur'
					}],
					adress: [{
						required: true,
						message: '请输入具体地址',
						trigger: 'change'
					}],

				},
			}
		},
		watch: {},
		mounted() {
			// this.getData()
		},
		methods: {
			// 弹窗保存按钮  新建/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.dialogTitle == "新建站点") {
							this.addCommunitySite()
						} else {
							this.updateCommunitySite()
						}
					} else {
						return false;
					}
				});
			},
			// 新建站点
			addCommunitySite() {
				let obj = {
					communityId: this.creatObj.communityId, //
					communitySiteName: this.creatObj.name, //站点名称
					communitySiteAddress: this.creatObj.adress || "", //社区地址
					communitySiteLongitude: this.creatObj.lng || "", //社区经度
					communitySiteLatitude: this.creatObj.lat || "" //社区纬度
				}
				this.$api.addCommunitySite(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新建站点成功',
								type: 'success'
							});
							setTimeout(() => {
								// 刷新社区列表   
								this.rushData()
							}, 500)
						})
					}
				})
			},
			// 刷新 社区列表和设备的站点选择列表
			rushData() {
				this.$emit('moduleZero', {
					k: 1,
					communityId: this.searchObj.communityId
				})
				this.$emit('moduleFour', this.searchObj.communityId)
			},
			// 编辑站点请求
			updateCommunitySite() {
				let obj = {
					communityId: this.creatObj.communityId, //
					communitySiteId: this.creatObj.communitySiteId, //
					communitySiteName: this.creatObj.name, //站点名称
					communitySiteAddress: this.creatObj.adress || "", //站点地址
					communitySiteLongitude: this.creatObj.lng || "", //站点经度
					communitySiteLatitude: this.creatObj.lat || "" //站点纬度
				}
				this.$api.updateCommunitySite(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '站点修改成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData(this.creatObj)
								this.$emit('moduleFour', this.creatObj.communityId)
							}, 500)
						})
					}
				})
			},
			// 获取站点信息
			getselectCommunitySite(id) {
				this.$api.selectCommunitySite({
					communitySiteId: id
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "creatObj", {
							name: res.obj.communitySiteName,
							communityId: this.searchObj.communityId,
							communitySiteId: id,
							adress: res.obj.communitySiteAddress,
							areaValue: [],
							provinceCode: res.obj.provinceCode,
							cityCode: res.obj.cityCode,
							areaCode: res.obj.areaCode,
							// 经度
							lng: res.obj.communitySiteLongitude,
							// 维度
							lat: res.obj.communitySiteLatitude
						})
						if (res.obj.provinceCode) {
							this.creatObj.areaValue.push(res.obj.provinceCode)
							if (res.obj.cityCode) {
								this.creatObj.areaValue.push(res.obj.cityCode)
								if (res.obj.areaCode) {
									this.creatObj.areaValue.push(res.obj.areaCode)
								}
							}
						}
						this.$nextTick(() => {
							this.dialogVisible = true
							// this.$refs.ruleForm2.clearValidate()
						})
					}
				})
			},
			// 1编辑 5新增 
			openDia(n, item) {
				if (n == 1) { //详情
					this.dialogTitle = "站点信息"
					this.getselectCommunitySite(item.communitySiteId)
					this.initMap()
				} else if (n == 5) { //新增
					this.dialogTitle = "新建站点"
					this.$set(this, "creatObj", {
						name: "",
						communityId: this.searchObj.communityId,
						type: "",
						adress: "",
						areaValue: [],
						// 经度
						lng: "",
						// 维度
						lat: ""
					})
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm2.clearValidate()
						this.initMap()
					})
				}

			},
			addMarker(obj) {
				console.log(obj.location)
				console.log(obj)
				this.creatObj.adress = obj.name
				this.creatObj.lng = obj.location.lng
				this.creatObj.lat = obj.location.lat
				this.map.setCenter([obj.location.lng, obj.location.lat])
				this.map.clearMap();
				var marker = new Amap.Marker({
					position: [obj.location.lng, obj.location.lat], //定义图标的位置
					offset: new Amap.Pixel(0, 0), //设置图标偏移量
					// icon: icons, //自定义图标路径
					draggable: false, //是否可以拖拽
					// cursor: 'move', //方式移动
				});
				//设置文本
				marker.setLabel({
					direction: 'top',
					offset: new AMap.Pixel(0, -10), //设置文本标注偏移量
					content: `<div class="infoShow">
								  <p class="address">${this.creatObj.adress}</p>
								</div>`, //设置文本标注内容
				});
				console.log([obj.location.lng, obj.location.lat])
				this.map.add(marker); //往地图上添加标注
			},
			initMap() {
				let that = this;
				AMapLoader.load({
					// key: '2d6486ec1e527d7e0597a7e73089a11b',//测试环境
					key: 'f0973413d1838d34702c84208aa119fc', //正式环境
					version: '2.0',
					plugins: ['AMap.AutoComplete', 'AMap.PlaceSearch'],
					// ['AMap.PlaceSearch', 'AMap.Geocoder', 'AMap.AutoComplete','AMap.PositionPicker'],
				}).then(AMap => {
					Amap = AMap;
					that.map = new AMap.Map('mapBox', {
						// resizeEnable: true,
						center: ['106.901367', '34.905904'],
						zoom: 12, //初始化地图级别
					})
					if (!that.auto) {
						//引入高德地图的空间绑定使用
						that.auto = new AMap.AutoComplete({
							input: 'userInput', //绑定的搜索关键字的input标签ID，用这个注册
							city: ""
						})
						this.auto.on("select", this.select)
					}

					if (that.creatObj.lng && that.creatObj.lng) {
						let obj = {
							location: {
								lng: that.creatObj.lng,
								lat: that.creatObj.lat,

							},
							name: that.creatObj.adress,
							adress: that.creatObj.adress
						}

						that.addMarker(obj)
					}

				})
			},
			select(e) {
				this.addMarker(e.poi)
				// this.placeSearch.setCity(e.poi.adcode)
				// this.placeSearch.search(e.poi.name) //关键字查询查询
			},
			// 获取站点列表
			getData(n) {

				this.loading = true
				if (n.communityId) { //社区ID
					if (n.provinceName) { //省市区赋值
						this.$set(this, "area", ((n.provinceName || "") + "/" + (n.cityName || '') + "/" + (n.areaName ||
							'')))
					} else {
						this.$set(this, "area", '')
					}
					this.searchObj.communityId = n.communityId
					this.searchObj.pageNo = 1
					this.active = -1
				}
				this.$api.listCommunitySite(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "stationList", res.obj.list || [])
						this.$set(this, "total", res.obj.total || 0)
					}
				})

			},
			// 1编辑 2删除
			itemClick(item, inx, n) {
				let that = this
				if (n == 1) {
					this.openDia(n, item)
				} else if (n == 2) {
					if (item.communityEquipmentNumber > 1) { //判断是否关联设备
						this.$confirm('该充电站存在关联设备，无法删除', '提示', {
							confirmButtonText: '确定',
							type: 'warning'
						}).then(() => {

						}).catch(() => {

						});
					} else {
						this.$confirm('是否确认删除该站点?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							that.$api.deleteCommunitySite({
								communitySiteId: item.communitySiteId
							}).then((res) => {
								if (res.returnCode == 200) {
									that.$message({
										type: 'success',
										message: '删除成功!'
									});
									setTimeout(() => {
										this.rushData()
									}, 500)
								}
							})
						}).catch(() => {

						});
					}

				}
			},
			// 点击站点 刷新设备列表
			stationClick(n, inx) {
				this.active = inx
				this.$emit('moduleTwo', n)
			},
			// 上一页 向左
			toLeft() {
				if (this.searchObj.pageNo == 1) {
					return false
				}
				this.searchObj.pageNo -= 1
				this.right = false
				this.$nextTick(() => {
					this.getData({})
				})
			},
			// 下一页 向右
			toRight() {
				if (this.searchObj.pageNo * 3 >= this.total) {
					return false
				}
				this.searchObj.pageNo += 1
				this.left = false
				this.$nextTick(() => {
					this.getData({})
				})
			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				this.$set(this.creatObj, "provinceCode", nodesInfo[0].path[0] || "")
				this.$set(this.creatObj, "cityCode", nodesInfo[0].path[1] || "")
				this.$set(this.creatObj, "areaCode", nodesInfo[0].path[2] || "")
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./stationManagement.scss"
</style>